// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/css/typography.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/swiper/swiper.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/swiper/modules/navigation.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/swiper/modules/pagination.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/swiper/modules/scrollbar.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles.css */
/* ! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1rem;
  padding-left: 1rem;
}
@media (min-width: 500px) {
  .container {
    max-width: 500px;
  }
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1440px) {
  .container {
    max-width: 1440px;
  }
}
@media (min-width: 1921px) {
  .container {
    max-width: 1921px;
  }
}
#nma-gallery-root :is(.pointer-events-none) {
  pointer-events: none;
}
#nma-gallery-root :is(.pointer-events-auto) {
  pointer-events: auto;
}
#nma-gallery-root :is(.\\!visible) {
  visibility: visible !important;
}
#nma-gallery-root :is(.visible) {
  visibility: visible;
}
#nma-gallery-root :is(.invisible) {
  visibility: hidden;
}
#nma-gallery-root :is(.fixed) {
  position: fixed;
}
#nma-gallery-root :is(.absolute) {
  position: absolute;
}
#nma-gallery-root :is(.relative) {
  position: relative;
}
#nma-gallery-root :is(.sticky) {
  position: sticky;
}
#nma-gallery-root :is(.inset-0) {
  inset: 0px;
}
#nma-gallery-root :is(.-left-14) {
  left: -3.5rem;
}
#nma-gallery-root :is(.-right-14) {
  right: -3.5rem;
}
#nma-gallery-root :is(.bottom-4) {
  bottom: 1rem;
}
#nma-gallery-root :is(.bottom-\\[90\\%\\]) {
  bottom: 90%;
}
#nma-gallery-root :is(.bottom-full) {
  bottom: 100%;
}
#nma-gallery-root :is(.left-0) {
  left: 0px;
}
#nma-gallery-root :is(.left-1\\/2) {
  left: 50%;
}
#nma-gallery-root :is(.left-2) {
  left: 0.5rem;
}
#nma-gallery-root :is(.left-3) {
  left: 0.75rem;
}
#nma-gallery-root :is(.left-6) {
  left: 1.5rem;
}
#nma-gallery-root :is(.left-\\[50\\%\\]) {
  left: 50%;
}
#nma-gallery-root :is(.right-0) {
  right: 0px;
}
#nma-gallery-root :is(.right-4) {
  right: 1rem;
}
#nma-gallery-root :is(.right-5) {
  right: 1.25rem;
}
#nma-gallery-root :is(.right-6) {
  right: 1.5rem;
}
#nma-gallery-root :is(.right-\\[12px\\]) {
  right: 12px;
}
#nma-gallery-root :is(.top-0) {
  top: 0px;
}
#nma-gallery-root :is(.top-1\\/2) {
  top: 50%;
}
#nma-gallery-root :is(.top-2) {
  top: 0.5rem;
}
#nma-gallery-root :is(.top-6) {
  top: 1.5rem;
}
#nma-gallery-root :is(.top-\\[50\\%\\]) {
  top: 50%;
}
#nma-gallery-root :is(.top-full) {
  top: 100%;
}
#nma-gallery-root :is(.z-10) {
  z-index: 10;
}
#nma-gallery-root :is(.z-20) {
  z-index: 20;
}
#nma-gallery-root :is(.z-30) {
  z-index: 30;
}
#nma-gallery-root :is(.z-80) {
  z-index: 80;
}
#nma-gallery-root :is(.z-\\[3333\\]) {
  z-index: 3333;
}
#nma-gallery-root :is(.z-\\[9999\\]) {
  z-index: 9999;
}
#nma-gallery-root :is(.col-span-1) {
  grid-column: span 1 / span 1;
}
#nma-gallery-root :is(.mx-auto) {
  margin-left: auto;
  margin-right: auto;
}
#nma-gallery-root :is(.my-2) {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
#nma-gallery-root :is(.my-\\[48px\\]) {
  margin-top: 48px;
  margin-bottom: 48px;
}
#nma-gallery-root :is(.-mb-1) {
  margin-bottom: -0.25rem;
}
#nma-gallery-root :is(.-mt-1) {
  margin-top: -0.25rem;
}
#nma-gallery-root :is(.mb-2) {
  margin-bottom: 0.5rem;
}
#nma-gallery-root :is(.mb-3) {
  margin-bottom: 0.75rem;
}
#nma-gallery-root :is(.mb-4) {
  margin-bottom: 1rem;
}
#nma-gallery-root :is(.mb-5) {
  margin-bottom: 1.25rem;
}
#nma-gallery-root :is(.mb-6) {
  margin-bottom: 1.5rem;
}
#nma-gallery-root :is(.mb-\\[16px\\]) {
  margin-bottom: 16px;
}
#nma-gallery-root :is(.mb-\\[32px\\]) {
  margin-bottom: 32px;
}
#nma-gallery-root :is(.mb-\\[36px\\]) {
  margin-bottom: 36px;
}
#nma-gallery-root :is(.ml-1) {
  margin-left: 0.25rem;
}
#nma-gallery-root :is(.ml-7) {
  margin-left: 1.75rem;
}
#nma-gallery-root :is(.ml-auto) {
  margin-left: auto;
}
#nma-gallery-root :is(.mr-2) {
  margin-right: 0.5rem;
}
#nma-gallery-root :is(.mr-3) {
  margin-right: 0.75rem;
}
#nma-gallery-root :is(.mr-4) {
  margin-right: 1rem;
}
#nma-gallery-root :is(.mr-6) {
  margin-right: 1.5rem;
}
#nma-gallery-root :is(.mr-\\[33px\\]) {
  margin-right: 33px;
}
#nma-gallery-root :is(.mt-1) {
  margin-top: 0.25rem;
}
#nma-gallery-root :is(.mt-2) {
  margin-top: 0.5rem;
}
#nma-gallery-root :is(.mt-4) {
  margin-top: 1rem;
}
#nma-gallery-root :is(.mt-6) {
  margin-top: 1.5rem;
}
#nma-gallery-root :is(.mt-\\[96px\\]) {
  margin-top: 96px;
}
#nma-gallery-root :is(.box-border) {
  box-sizing: border-box;
}
#nma-gallery-root :is(.line-clamp-3) {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
#nma-gallery-root :is(.block) {
  display: block;
}
#nma-gallery-root :is(.inline-block) {
  display: inline-block;
}
#nma-gallery-root :is(.inline) {
  display: inline;
}
#nma-gallery-root :is(.flex) {
  display: flex;
}
#nma-gallery-root :is(.inline-flex) {
  display: inline-flex;
}
#nma-gallery-root :is(.grid) {
  display: grid;
}
#nma-gallery-root :is(.hidden) {
  display: none;
}
#nma-gallery-root :is(.size-2) {
  width: 0.5rem;
  height: 0.5rem;
}
#nma-gallery-root :is(.size-4) {
  width: 1rem;
  height: 1rem;
}
#nma-gallery-root :is(.size-5) {
  width: 1.25rem;
  height: 1.25rem;
}
#nma-gallery-root :is(.h-0) {
  height: 0px;
}
#nma-gallery-root :is(.h-10) {
  height: 2.5rem;
}
#nma-gallery-root :is(.h-4) {
  height: 1rem;
}
#nma-gallery-root :is(.h-8) {
  height: 2rem;
}
#nma-gallery-root :is(.h-\\[116px\\]) {
  height: 116px;
}
#nma-gallery-root :is(.h-\\[14px\\]) {
  height: 14px;
}
#nma-gallery-root :is(.h-\\[15px\\]) {
  height: 15px;
}
#nma-gallery-root :is(.h-\\[214px\\]) {
  height: 214px;
}
#nma-gallery-root :is(.h-\\[218px\\]) {
  height: 218px;
}
#nma-gallery-root :is(.h-\\[288px\\]) {
  height: 288px;
}
#nma-gallery-root :is(.h-\\[330px\\]) {
  height: 330px;
}
#nma-gallery-root :is(.h-\\[40px\\]) {
  height: 40px;
}
#nma-gallery-root :is(.h-\\[415px\\]) {
  height: 415px;
}
#nma-gallery-root :is(.h-\\[420px\\]) {
  height: 420px;
}
#nma-gallery-root :is(.h-\\[68px\\]) {
  height: 68px;
}
#nma-gallery-root :is(.h-\\[80px\\]) {
  height: 80px;
}
#nma-gallery-root :is(.h-\\[90\\%\\]) {
  height: 90%;
}
#nma-gallery-root :is(.h-\\[99px\\]) {
  height: 99px;
}
#nma-gallery-root :is(.h-full) {
  height: 100%;
}
#nma-gallery-root :is(.h-px) {
  height: 1px;
}
#nma-gallery-root :is(.max-h-\\[160px\\]) {
  max-height: 160px;
}
#nma-gallery-root :is(.max-h-\\[16px\\]) {
  max-height: 16px;
}
#nma-gallery-root :is(.max-h-\\[172px\\]) {
  max-height: 172px;
}
#nma-gallery-root :is(.max-h-\\[200px\\]) {
  max-height: 200px;
}
#nma-gallery-root :is(.max-h-\\[24px\\]) {
  max-height: 24px;
}
#nma-gallery-root :is(.max-h-\\[311px\\]) {
  max-height: 311px;
}
#nma-gallery-root :is(.max-h-\\[350px\\]) {
  max-height: 350px;
}
#nma-gallery-root :is(.max-h-\\[500px\\]) {
  max-height: 500px;
}
#nma-gallery-root :is(.max-h-\\[506px\\]) {
  max-height: 506px;
}
#nma-gallery-root :is(.min-h-\\[280px\\]) {
  min-height: 280px;
}
#nma-gallery-root :is(.min-h-\\[375px\\]) {
  min-height: 375px;
}
#nma-gallery-root :is(.w-0) {
  width: 0px;
}
#nma-gallery-root :is(.w-1\\/2) {
  width: 50%;
}
#nma-gallery-root :is(.w-1\\/3) {
  width: 33.333333%;
}
#nma-gallery-root :is(.w-14) {
  width: 3.5rem;
}
#nma-gallery-root :is(.w-4) {
  width: 1rem;
}
#nma-gallery-root :is(.w-\\[14px\\]) {
  width: 14px;
}
#nma-gallery-root :is(.w-\\[15px\\]) {
  width: 15px;
}
#nma-gallery-root :is(.w-\\[192px\\]) {
  width: 192px;
}
#nma-gallery-root :is(.w-\\[205px\\]) {
  width: 205px;
}
#nma-gallery-root :is(.w-\\[280px\\]) {
  width: 280px;
}
#nma-gallery-root :is(.w-\\[288px\\]) {
  width: 288px;
}
#nma-gallery-root :is(.w-\\[300px\\]) {
  width: 300px;
}
#nma-gallery-root :is(.w-\\[320px\\]) {
  width: 320px;
}
#nma-gallery-root :is(.w-\\[564px\\]) {
  width: 564px;
}
#nma-gallery-root :is(.w-\\[568px\\]) {
  width: 568px;
}
#nma-gallery-root :is(.w-\\[620px\\]) {
  width: 620px;
}
#nma-gallery-root :is(.w-\\[80px\\]) {
  width: 80px;
}
#nma-gallery-root :is(.w-\\[93px\\]) {
  width: 93px;
}
#nma-gallery-root :is(.w-full) {
  width: 100%;
}
#nma-gallery-root :is(.w-max) {
  width: max-content;
}
#nma-gallery-root :is(.w-px) {
  width: 1px;
}
#nma-gallery-root :is(.min-w-0) {
  min-width: 0px;
}
#nma-gallery-root :is(.min-w-\\[220px\\]) {
  min-width: 220px;
}
#nma-gallery-root :is(.min-w-\\[320px\\]) {
  min-width: 320px;
}
#nma-gallery-root :is(.min-w-\\[40px\\]) {
  min-width: 40px;
}
#nma-gallery-root :is(.max-w-\\[1152px\\]) {
  max-width: 1152px;
}
#nma-gallery-root :is(.max-w-\\[120px\\]) {
  max-width: 120px;
}
#nma-gallery-root :is(.max-w-\\[1280px\\]) {
  max-width: 1280px;
}
#nma-gallery-root :is(.max-w-\\[246px\\]) {
  max-width: 246px;
}
#nma-gallery-root :is(.max-w-\\[312px\\]) {
  max-width: 312px;
}
#nma-gallery-root :is(.max-w-\\[350px\\]) {
  max-width: 350px;
}
#nma-gallery-root :is(.max-w-\\[392px\\]) {
  max-width: 392px;
}
#nma-gallery-root :is(.max-w-\\[436px\\]) {
  max-width: 436px;
}
#nma-gallery-root :is(.max-w-\\[560px\\]) {
  max-width: 560px;
}
#nma-gallery-root :is(.max-w-\\[729px\\]) {
  max-width: 729px;
}
#nma-gallery-root :is(.max-w-\\[756px\\]) {
  max-width: 756px;
}
#nma-gallery-root :is(.max-w-\\[980px\\]) {
  max-width: 980px;
}
#nma-gallery-root :is(.flex-1) {
  flex: 1 1;
}
#nma-gallery-root :is(.flex-\\[2\\]) {
  flex: 2 1;
}
#nma-gallery-root :is(.flex-shrink-0) {
  flex-shrink: 0;
}
#nma-gallery-root :is(.grow) {
  flex-grow: 1;
}
#nma-gallery-root :is(.origin-right) {
  transform-origin: right;
}
#nma-gallery-root :is(.-translate-x-1\\/2) {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#nma-gallery-root :is(.-translate-y-1\\/2) {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#nma-gallery-root :is(.translate-x-32) {
  --tw-translate-x: 8rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#nma-gallery-root :is(.translate-x-\\[-50\\%\\]) {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#nma-gallery-root :is(.translate-y-\\[-50\\%\\]) {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#nma-gallery-root :is(.-rotate-180) {
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#nma-gallery-root :is(.-rotate-45) {
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#nma-gallery-root :is(.rotate-0) {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#nma-gallery-root :is(.rotate-180) {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#nma-gallery-root :is(.rotate-45) {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#nma-gallery-root :is(.rotate-90) {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#nma-gallery-root :is(.transform) {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
#nma-gallery-root :is(.animate-shimmer) {
  animation: shimmer 1.8s infinite;
}
#nma-gallery-root :is(.cursor-not-allowed) {
  cursor: not-allowed;
}
#nma-gallery-root :is(.cursor-pointer) {
  cursor: pointer;
}
#nma-gallery-root :is(.select-none) {
  -webkit-user-select: none;
          user-select: none;
}
#nma-gallery-root :is(.resize) {
  resize: both;
}
#nma-gallery-root :is(.list-disc) {
  list-style-type: disc;
}
#nma-gallery-root :is(.appearance-none) {
  appearance: none;
}
#nma-gallery-root :is(.grid-cols-1) {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
#nma-gallery-root :is(.flex-col) {
  flex-direction: column;
}
#nma-gallery-root :is(.flex-wrap) {
  flex-wrap: wrap;
}
#nma-gallery-root :is(.items-start) {
  align-items: flex-start;
}
#nma-gallery-root :is(.items-center) {
  align-items: center;
}
#nma-gallery-root :is(.items-baseline) {
  align-items: baseline;
}
#nma-gallery-root :is(.justify-center) {
  justify-content: center;
}
#nma-gallery-root :is(.justify-between) {
  justify-content: space-between;
}
#nma-gallery-root :is(.gap-1) {
  gap: 0.25rem;
}
#nma-gallery-root :is(.gap-2) {
  gap: 0.5rem;
}
#nma-gallery-root :is(.gap-3) {
  gap: 0.75rem;
}
#nma-gallery-root :is(.gap-4) {
  gap: 1rem;
}
#nma-gallery-root :is(.gap-\\[0_60px\\]) {
  gap: 0 60px;
}
#nma-gallery-root :is(.gap-\\[10px\\]) {
  gap: 10px;
}
#nma-gallery-root :is(.gap-\\[24px\\]) {
  gap: 24px;
}
#nma-gallery-root :is(.gap-\\[40px\\]) {
  gap: 40px;
}
#nma-gallery-root :is(.gap-x-\\[52px\\]) {
  column-gap: 52px;
}
#nma-gallery-root :is(.gap-y-2) {
  row-gap: 0.5rem;
}
#nma-gallery-root :is(.overflow-auto) {
  overflow: auto;
}
#nma-gallery-root :is(.overflow-hidden) {
  overflow: hidden;
}
#nma-gallery-root :is(.overflow-y-auto) {
  overflow-y: auto;
}
#nma-gallery-root :is(.overflow-x-hidden) {
  overflow-x: hidden;
}
#nma-gallery-root :is(.truncate) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#nma-gallery-root :is(.text-ellipsis) {
  text-overflow: ellipsis;
}
#nma-gallery-root :is(.text-clip) {
  text-overflow: clip;
}
#nma-gallery-root :is(.whitespace-normal) {
  white-space: normal;
}
#nma-gallery-root :is(.whitespace-nowrap) {
  white-space: nowrap;
}
#nma-gallery-root :is(.whitespace-pre-wrap) {
  white-space: pre-wrap;
}
#nma-gallery-root :is(.text-wrap) {
  text-wrap: wrap;
}
#nma-gallery-root :is(.text-nowrap) {
  text-wrap: nowrap;
}
#nma-gallery-root :is(.break-words) {
  overflow-wrap: break-word;
}
#nma-gallery-root :is(.rounded) {
  border-radius: 0.25rem;
}
#nma-gallery-root :is(.rounded-2xl) {
  border-radius: 1rem;
}
#nma-gallery-root :is(.rounded-3xl) {
  border-radius: 1.5rem;
}
#nma-gallery-root :is(.rounded-6) {
  border-radius: 6px;
}
#nma-gallery-root :is(.rounded-8) {
  border-radius: 8px;
}
#nma-gallery-root :is(.rounded-\\[14px\\]) {
  border-radius: 14px;
}
#nma-gallery-root :is(.rounded-\\[16px\\]) {
  border-radius: 16px;
}
#nma-gallery-root :is(.rounded-\\[1px\\]) {
  border-radius: 1px;
}
#nma-gallery-root :is(.rounded-\\[2px\\]) {
  border-radius: 2px;
}
#nma-gallery-root :is(.rounded-\\[40px\\]) {
  border-radius: 40px;
}
#nma-gallery-root :is(.rounded-full) {
  border-radius: 9999px;
}
#nma-gallery-root :is(.rounded-lg) {
  border-radius: 0.5rem;
}
#nma-gallery-root :is(.rounded-md) {
  border-radius: 0.375rem;
}
#nma-gallery-root :is(.border) {
  border-width: 1px;
}
#nma-gallery-root :is(.border-4) {
  border-width: 4px;
}
#nma-gallery-root :is(.border-\\[2px\\]) {
  border-width: 2px;
}
#nma-gallery-root :is(.border-b) {
  border-bottom-width: 1px;
}
#nma-gallery-root :is(.border-l-\\[6px\\]) {
  border-left-width: 6px;
}
#nma-gallery-root :is(.border-r) {
  border-right-width: 1px;
}
#nma-gallery-root :is(.border-r-\\[6px\\]) {
  border-right-width: 6px;
}
#nma-gallery-root :is(.border-t) {
  border-top-width: 1px;
}
#nma-gallery-root :is(.border-t-\\[6px\\]) {
  border-top-width: 6px;
}
#nma-gallery-root :is(.border-solid) {
  border-style: solid;
}
#nma-gallery-root :is(.border-none) {
  border-style: none;
}
#nma-gallery-root :is(.border-\\[\\#6E6E6E\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(110 110 110 / var(--tw-border-opacity));
}
#nma-gallery-root :is(.border-\\[\\#9B9B9B\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(155 155 155 / var(--tw-border-opacity));
}
#nma-gallery-root :is(.border-\\[\\#BDBDBD\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(189 189 189 / var(--tw-border-opacity));
}
#nma-gallery-root :is(.border-\\[\\#D7D7D7\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(215 215 215 / var(--tw-border-opacity));
}
#nma-gallery-root :is(.border-\\[\\#DE0000\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(222 0 0 / var(--tw-border-opacity));
}
#nma-gallery-root :is(.border-\\[\\#a2a9b0\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(162 169 176 / var(--tw-border-opacity));
}
#nma-gallery-root :is(.border-\\[\\#e7eaee\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(231 234 238 / var(--tw-border-opacity));
}
#nma-gallery-root :is(.border-black) {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
#nma-gallery-root :is(.border-transparent) {
  border-color: transparent;
}
#nma-gallery-root :is(.border-l-transparent) {
  border-left-color: transparent;
}
#nma-gallery-root :is(.border-r-transparent) {
  border-right-color: transparent;
}
#nma-gallery-root :is(.border-t-\\[\\#4A4A4A\\]) {
  --tw-border-opacity: 1;
  border-top-color: rgb(74 74 74 / var(--tw-border-opacity));
}
#nma-gallery-root :is(.\\!bg-\\[\\#eee8ff\\]) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(238 232 255 / var(--tw-bg-opacity)) !important;
}
#nma-gallery-root :is(.bg-\\[\\#4A4A4A\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(74 74 74 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#505050\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(80 80 80 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#B59745\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(181 151 69 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#B6B6B6\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(182 182 182 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#D4D4D4\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#D7D7D7\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(215 215 215 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#DFB26D\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(223 178 109 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#EBFF00\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(235 255 0 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#F1F1F1\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(241 241 241 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#F4F4F4\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#FAFAFA\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#FD900C\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(253 144 12 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-\\[\\#e7eaee\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(231 234 238 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-black) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-black\\/50) {
  background-color: rgb(0 0 0 / 0.5);
}
#nma-gallery-root :is(.bg-grey) {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-orange) {
  --tw-bg-opacity: 1;
  background-color: rgb(253 144 12 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-transparent) {
  background-color: transparent;
}
#nma-gallery-root :is(.bg-white) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
#nma-gallery-root :is(.bg-gradient-to-b) {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
#nma-gallery-root :is(.bg-gradient-to-t) {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
#nma-gallery-root :is(.from-\\[\\#F6F6F6\\]) {
  --tw-gradient-from: #F6F6F6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(246 246 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
#nma-gallery-root :is(.from-\\[\\#FFFFFF\\]) {
  --tw-gradient-from: #FFFFFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
#nma-gallery-root :is(.from-transparent) {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
#nma-gallery-root :is(.via-white\\/60) {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
#nma-gallery-root :is(.to-\\[\\#6E6E6E\\]) {
  --tw-gradient-to: #6E6E6E var(--tw-gradient-to-position);
}
#nma-gallery-root :is(.to-\\[\\#FFFFFF\\]) {
  --tw-gradient-to: #FFFFFF var(--tw-gradient-to-position);
}
#nma-gallery-root :is(.to-transparent) {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
#nma-gallery-root :is(.bg-center) {
  background-position: center;
}
#nma-gallery-root :is(.bg-no-repeat) {
  background-repeat: no-repeat;
}
#nma-gallery-root :is(.fill-black) {
  fill: #000000;
}
#nma-gallery-root :is(.object-cover) {
  object-fit: cover;
}
#nma-gallery-root :is(.p-0) {
  padding: 0px;
}
#nma-gallery-root :is(.p-2) {
  padding: 0.5rem;
}
#nma-gallery-root :is(.p-4) {
  padding: 1rem;
}
#nma-gallery-root :is(.p-6) {
  padding: 1.5rem;
}
#nma-gallery-root :is(.p-\\[10px\\]) {
  padding: 10px;
}
#nma-gallery-root :is(.p-\\[11px\\]) {
  padding: 11px;
}
#nma-gallery-root :is(.p-\\[16px\\]) {
  padding: 16px;
}
#nma-gallery-root :is(.px-1) {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
#nma-gallery-root :is(.px-1\\.5) {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
#nma-gallery-root :is(.px-10) {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
#nma-gallery-root :is(.px-16) {
  padding-left: 4rem;
  padding-right: 4rem;
}
#nma-gallery-root :is(.px-2) {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
#nma-gallery-root :is(.px-3) {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
#nma-gallery-root :is(.px-4) {
  padding-left: 1rem;
  padding-right: 1rem;
}
#nma-gallery-root :is(.px-6) {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
#nma-gallery-root :is(.px-\\[10px\\]) {
  padding-left: 10px;
  padding-right: 10px;
}
#nma-gallery-root :is(.py-1) {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
#nma-gallery-root :is(.py-1\\.5) {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
#nma-gallery-root :is(.py-2) {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
#nma-gallery-root :is(.py-2\\.5) {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
#nma-gallery-root :is(.py-3) {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
#nma-gallery-root :is(.py-4) {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
#nma-gallery-root :is(.py-5) {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
#nma-gallery-root :is(.py-6) {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
#nma-gallery-root :is(.py-\\[14px\\]) {
  padding-top: 14px;
  padding-bottom: 14px;
}
#nma-gallery-root :is(.py-\\[5px\\]) {
  padding-top: 5px;
  padding-bottom: 5px;
}
#nma-gallery-root :is(.py-\\[6px\\]) {
  padding-top: 6px;
  padding-bottom: 6px;
}
#nma-gallery-root :is(.py-\\[9px\\]) {
  padding-top: 9px;
  padding-bottom: 9px;
}
#nma-gallery-root :is(.pb-12) {
  padding-bottom: 3rem;
}
#nma-gallery-root :is(.pb-3) {
  padding-bottom: 0.75rem;
}
#nma-gallery-root :is(.pb-4) {
  padding-bottom: 1rem;
}
#nma-gallery-root :is(.pb-\\[10px\\]) {
  padding-bottom: 10px;
}
#nma-gallery-root :is(.pb-\\[50px\\]) {
  padding-bottom: 50px;
}
#nma-gallery-root :is(.pl-16) {
  padding-left: 4rem;
}
#nma-gallery-root :is(.pl-4) {
  padding-left: 1rem;
}
#nma-gallery-root :is(.pr-1) {
  padding-right: 0.25rem;
}
#nma-gallery-root :is(.pr-3) {
  padding-right: 0.75rem;
}
#nma-gallery-root :is(.pr-6) {
  padding-right: 1.5rem;
}
#nma-gallery-root :is(.pt-12) {
  padding-top: 3rem;
}
#nma-gallery-root :is(.pt-2) {
  padding-top: 0.5rem;
}
#nma-gallery-root :is(.pt-6) {
  padding-top: 1.5rem;
}
#nma-gallery-root :is(.text-left) {
  text-align: left;
}
#nma-gallery-root :is(.text-center) {
  text-align: center;
}
#nma-gallery-root :is(.text-start) {
  text-align: start;
}
#nma-gallery-root :is(.font-TCCC) {
  font-family: TCCC-UnityHeadline, ui-sans-serif, system-ui;
}
#nma-gallery-root :is(.font-TCCCtext) {
  font-family: TCCC-UnityText, ui-sans-serif, system-ui;
}
#nma-gallery-root :is(.text-14) {
  font-size: 14px;
  line-height: 18px;
}
#nma-gallery-root :is(.text-2xl) {
  font-size: 1.5rem;
  line-height: 2rem;
}
#nma-gallery-root :is(.text-\\[12px\\]) {
  font-size: 12px;
}
#nma-gallery-root :is(.text-\\[14px\\]) {
  font-size: 14px;
}
#nma-gallery-root :is(.text-\\[16px\\]) {
  font-size: 16px;
}
#nma-gallery-root :is(.text-\\[18px\\]) {
  font-size: 18px;
}
#nma-gallery-root :is(.text-\\[20px\\]) {
  font-size: 20px;
}
#nma-gallery-root :is(.text-\\[24px\\]) {
  font-size: 24px;
}
#nma-gallery-root :is(.text-\\[36px\\]) {
  font-size: 36px;
}
#nma-gallery-root :is(.text-\\[64px\\]) {
  font-size: 64px;
}
#nma-gallery-root :is(.text-base) {
  font-size: 1rem;
  line-height: 1.5rem;
}
#nma-gallery-root :is(.text-sm) {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
#nma-gallery-root :is(.text-xs) {
  font-size: 0.75rem;
  line-height: 1rem;
}
#nma-gallery-root :is(.\\!font-medium) {
  font-weight: 500 !important;
}
#nma-gallery-root :is(.font-\\[400\\]) {
  font-weight: 400;
}
#nma-gallery-root :is(.font-\\[600\\]) {
  font-weight: 600;
}
#nma-gallery-root :is(.font-\\[700\\]) {
  font-weight: 700;
}
#nma-gallery-root :is(.font-bold) {
  font-weight: 700;
}
#nma-gallery-root :is(.font-medium) {
  font-weight: 500;
}
#nma-gallery-root :is(.font-normal) {
  font-weight: 400;
}
#nma-gallery-root :is(.font-semibold) {
  font-weight: 600;
}
#nma-gallery-root :is(.uppercase) {
  text-transform: uppercase;
}
#nma-gallery-root :is(.capitalize) {
  text-transform: capitalize;
}
#nma-gallery-root :is(.italic) {
  font-style: italic;
}
#nma-gallery-root :is(.leading-5) {
  line-height: 1.25rem;
}
#nma-gallery-root :is(.leading-6) {
  line-height: 1.5rem;
}
#nma-gallery-root :is(.leading-7) {
  line-height: 1.75rem;
}
#nma-gallery-root :is(.leading-\\[22px\\]) {
  line-height: 22px;
}
#nma-gallery-root :is(.leading-\\[24px\\]) {
  line-height: 24px;
}
#nma-gallery-root :is(.leading-\\[86px\\]) {
  line-height: 86px;
}
#nma-gallery-root :is(.tracking-\\[0\\%\\]) {
  letter-spacing: 0%;
}
#nma-gallery-root :is(.tracking-wide) {
  letter-spacing: 0.025em;
}
#nma-gallery-root :is(.text-\\[\\#121619\\]) {
  --tw-text-opacity: 1;
  color: rgb(18 22 25 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-\\[\\#191919\\]) {
  --tw-text-opacity: 1;
  color: rgb(25 25 25 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-\\[\\#1B0E00\\]) {
  --tw-text-opacity: 1;
  color: rgb(27 14 0 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-\\[\\#4C4C4C\\]) {
  --tw-text-opacity: 1;
  color: rgb(76 76 76 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-\\[\\#505050\\]) {
  --tw-text-opacity: 1;
  color: rgb(80 80 80 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-\\[\\#5f5f5f\\]) {
  --tw-text-opacity: 1;
  color: rgb(95 95 95 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-\\[\\#866431\\]) {
  --tw-text-opacity: 1;
  color: rgb(134 100 49 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-\\[\\#967337\\]) {
  --tw-text-opacity: 1;
  color: rgb(150 115 55 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-\\[\\#9B9B9B\\]) {
  --tw-text-opacity: 1;
  color: rgb(155 155 155 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-\\[\\#DE0000\\]) {
  --tw-text-opacity: 1;
  color: rgb(222 0 0 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-\\[\\#fff\\]) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-black) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-brown) {
  --tw-text-opacity: 1;
  color: rgb(68 43 0 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
#nma-gallery-root :is(.accent-black) {
  accent-color: #000000;
}
#nma-gallery-root :is(.opacity-0) {
  opacity: 0;
}
#nma-gallery-root :is(.opacity-30) {
  opacity: 0.3;
}
#nma-gallery-root :is(.opacity-50) {
  opacity: 0.5;
}
#nma-gallery-root :is(.shadow-\\[0px_4px_12px_0px_\\#3939391F\\]) {
  --tw-shadow: 0px 4px 12px 0px #3939391F;
  --tw-shadow-colored: 0px 4px 12px 0px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#nma-gallery-root :is(.shadow-lg) {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#nma-gallery-root :is(.shadow-md) {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#nma-gallery-root :is(.outline-none) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
#nma-gallery-root :is(.filter) {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
#nma-gallery-root :is(.transition) {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#nma-gallery-root :is(.transition-all) {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#nma-gallery-root :is(.transition-colors) {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#nma-gallery-root :is(.transition-opacity) {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#nma-gallery-root :is(.transition-transform) {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#nma-gallery-root :is(.duration-300) {
  transition-duration: 300ms;
}

body {
  background: #f4f4f4;
  font-family: 'TCCC-UnityText';
}

:not(#spcfty) swiper-container,
:not(#spcfty) swiper-slide {
  --swiper-navigation-size: 16px;
  width: 100%;
}

swiper-container::part(button-next),
swiper-container::part(button-prev) {
  display: none !important;
}

swiper-container::part(bullet-active) {
  background-color: #f70000 !important;
  opacity: 1 !important;
}

swiper-container::part(pagination) {
  background-color: #00000080 !important;
  width: -moz-fit-content !important;
  width: fit-content !important;
  border-radius: 24px !important;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  padding: 8px;
}

swiper-container::part(bullet) {
  background: linear-gradient(to bottom, #ffffff40, #6e6e6e40) !important;
  opacity: 1 !important;
}

swiper-container::part(bullet)::after {
  content: '';
  height: 6px;
  width: 6px;
  margin: 1px;
  border-radius: 16px;
  display: block;
  position: absolute;
  background-color: white;
}

swiper-slide {
  height: 415px;
  border-radius: 16px;
  overflow: hidden;
}

wpp-select-v2-16-0::part(placeholder) {
  font-family: 'TCCC-UnityText' !important;
}

wpp-select-v2-16-0::part(placeholder) > p.selected-item > span.selected-item-text-wrapper > span.selected-item-text {
  font-family: 'TCCC-UnityText' !important;
}

wpp-select-v2-16-0::part(total-text) {
  font-family: 'TCCC-UnityText' !important;
}

wpp-full-screen-modal-v2-16-0::part(body-wrapper) {
  padding-left: 80px !important;
  padding-right: 80px !important;
  padding-top: 0px !important;
}

#nma-gallery-root :is(.placeholder\\:text-\\[\\#b1b0b0\\])::placeholder {
  --tw-text-opacity: 1;
  color: rgb(177 176 176 / var(--tw-text-opacity));
}

#nma-gallery-root :is(.checked\\:bg-\\[\\#8508e8\\]:checked) {
  --tw-bg-opacity: 1;
  background-color: rgb(133 8 232 / var(--tw-bg-opacity));
}

#nma-gallery-root :is(.hover\\:border-\\[\\#697077\\]:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(105 112 119 / var(--tw-border-opacity));
}

#nma-gallery-root :is(.hover\\:border-\\[\\#DE0000\\]:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(222 0 0 / var(--tw-border-opacity));
}

#nma-gallery-root :is(.hover\\:border-black:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

#nma-gallery-root :is(.hover\\:\\!bg-\\[\\#f0f2F5\\]:hover) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 242 245 / var(--tw-bg-opacity)) !important;
}

#nma-gallery-root :is(.hover\\:bg-\\[\\#D4D4D4\\]:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}

#nma-gallery-root :is(.hover\\:bg-\\[\\#f0f2F5\\]:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(240 242 245 / var(--tw-bg-opacity));
}

#nma-gallery-root :is(.hover\\:bg-\\[\\#f0f2f5\\]:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(240 242 245 / var(--tw-bg-opacity));
}

#nma-gallery-root :is(.hover\\:text-\\[\\#000\\]:hover) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

#nma-gallery-root :is(.hover\\:text-black:hover) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

#nma-gallery-root :is(.hover\\:opacity-80:hover) {
  opacity: 0.8;
}

#nma-gallery-root :is(.hover\\:shadow-\\[0px_14px_24px_0px_\\#0000000F\\]:hover) {
  --tw-shadow: 0px 14px 24px 0px #0000000F;
  --tw-shadow-colored: 0px 14px 24px 0px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

#nma-gallery-root :is(.focus\\:border-black:focus) {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

#nma-gallery-root :is(.focus\\:text-\\[6E6E6E\\]:focus) {
  color: 6E6E6E;
}

#nma-gallery-root :is(.focus\\:outline-none:focus) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

#nma-gallery-root :is(.focus\\:ring-\\[\\#DE0000\\]:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(222 0 0 / var(--tw-ring-opacity));
}

#nma-gallery-root :is(.group:hover .group-hover\\:block) {
  display: block;
}

#nma-gallery-root :is(.group:hover .group-hover\\:translate-x-0) {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

#nma-gallery-root :is(.group:hover .group-hover\\:opacity-100) {
  opacity: 1;
}

#nma-gallery-root :is(.\\[\\&_path\\]\\:fill-\\[\\#505050\\] path) {
  fill: #505050;
}

#nma-gallery-root :is(.\\[\\&_path\\]\\:text-\\[\\#505050\\] path) {
  --tw-text-opacity: 1;
  color: rgb(80 80 80 / var(--tw-text-opacity));
}

#nma-gallery-root :is(.\\[\\&_swiper-container\\:\\:part\\(pagination\\)\\]\\:hidden swiper-container)::part(pagination) {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB,iEAA0B;AAA1B;;;CAA0B;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,0BAA0B,EAA1B,MAA0B;AAAA;AAA1B;;EAAA,gBAA0B;AAAA;AAA1B;;;;;;;;CAA0B;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,+HAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,mBAA0B;AAAA;AAA1B;;;;;CAA0B;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,cAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;AAA1B;EAAA,eAA0B;AAAA;AAA1B;EAAA,WAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,uBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,oBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,aAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,gBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,wBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,YAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,wBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,kBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;AAA1B;EAAA,UAA0B;AAAA;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,gBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,eAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAC1B;EAAA,WAAgC;EAAhC,kBAAgC;EAAhC,iBAAgC;EAAhC,mBAAgC;EAAhC;AAAgC;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAChC;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,aAA+B;EAA/B;AAA+B;AAA/B;EAAA,WAA+B;EAA/B;AAA+B;AAA/B;EAAA,cAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;IAAA;EAA+B;EAA/B;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,yBAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,gEAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B,4DAA+B;EAA/B,kDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B,kDAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,iGAA+B;EAA/B,kDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gKAA+B;EAA/B,wJAA+B;EAA/B,iLAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+FAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;;AAS/B;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,kCAA6B;EAA7B,6BAA6B;EAC7B,8BAA8B;EAC9B,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uEAAuE;EACvE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAlFA;EAAA,oBAmFA;EAnFA;AAmFA;;AAnFA;EAAA,kBAmFA;EAnFA;AAmFA;;AAnFA;EAAA,sBAmFA;EAnFA;AAmFA;;AAnFA;EAAA,sBAmFA;EAnFA;AAmFA;;AAnFA;EAAA,sBAmFA;EAnFA;AAmFA;;AAnFA;EAAA,6BAmFA;EAnFA;AAmFA;;AAnFA;EAAA,kBAmFA;EAnFA;AAmFA;;AAnFA;EAAA,kBAmFA;EAnFA;AAmFA;;AAnFA;EAAA,kBAmFA;EAnFA;AAmFA;;AAnFA;EAAA,oBAmFA;EAnFA;AAmFA;;AAnFA;EAAA,oBAmFA;EAnFA;AAmFA;;AAnFA;EAAA;AAmFA;;AAnFA;EAAA,wCAmFA;EAnFA,6DAmFA;EAnFA,kDAmFA;EAnFA;AAmFA;;AAnFA;EAAA,sBAmFA;EAnFA;AAmFA;;AAnFA;EAAA;AAmFA;;AAnFA;EAAA,8BAmFA;EAnFA;AAmFA;;AAnFA;EAAA,oBAmFA;EAnFA;AAmFA;;AAnFA;EAAA;AAmFA;;AAnFA;EAAA,qBAmFA;EAnFA;AAmFA;;AAnFA;EAAA;AAmFA;;AAnFA;EAAA;AAmFA;;AAnFA;EAAA,oBAmFA;EAnFA;AAmFA;;AAnFA;EAAA;AAmFA","sourcesContent":["/* src/styles.css */\n@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n@import 'assets/css/typography';\n\n@import 'swiper/css';\n@import 'swiper/css/navigation';\n@import 'swiper/css/pagination';\n@import 'swiper/css/scrollbar';\n\nbody {\n  background: #f4f4f4;\n  font-family: 'TCCC-UnityText';\n}\n\n:not(#spcfty) swiper-container,\n:not(#spcfty) swiper-slide {\n  --swiper-navigation-size: 16px;\n  width: 100%;\n}\n\nswiper-container::part(button-next),\nswiper-container::part(button-prev) {\n  display: none !important;\n}\n\nswiper-container::part(bullet-active) {\n  background-color: #f70000 !important;\n  opacity: 1 !important;\n}\n\nswiper-container::part(pagination) {\n  background-color: #00000080 !important;\n  width: fit-content !important;\n  border-radius: 24px !important;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  padding: 8px;\n}\n\nswiper-container::part(bullet) {\n  background: linear-gradient(to bottom, #ffffff40, #6e6e6e40) !important;\n  opacity: 1 !important;\n}\n\nswiper-container::part(bullet)::after {\n  content: '';\n  height: 6px;\n  width: 6px;\n  margin: 1px;\n  border-radius: 16px;\n  display: block;\n  position: absolute;\n  background-color: white;\n}\n\nswiper-slide {\n  height: 415px;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\nwpp-select-v2-16-0::part(placeholder) {\n  font-family: 'TCCC-UnityText' !important;\n}\n\nwpp-select-v2-16-0::part(placeholder) > p.selected-item > span.selected-item-text-wrapper > span.selected-item-text {\n  font-family: 'TCCC-UnityText' !important;\n}\n\nwpp-select-v2-16-0::part(total-text) {\n  font-family: 'TCCC-UnityText' !important;\n}\n\nwpp-full-screen-modal-v2-16-0::part(body-wrapper) {\n  padding-left: 80px !important;\n  padding-right: 80px !important;\n  padding-top: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
